module.exports = __webpack_public_path__ + "img/prints-danone.96acda81.png";